$(window).scroll(function () {
    var windowWidth = $(window).width();
    var menu = $('header#header');
    var body = $('body');
    var offset = menu.offset();    

    if (windowWidth > 770) {
        var scrollAfter = $('header#header').height();
    } else {
        var scrollAfter = 550;
    }

    if ($(window).scrollTop() > scrollAfter) {
        if (!menu.hasClass('header-fixed')) {
            menu.addClass('header-fixed');
            body.addClass('header-fixed');
        }

        $('.menu-item-has-children').removeClass('active');
        $('.sub-menu-wrapper').removeClass('active');
    } else {
        menu.removeClass('header-fixed');
        body.removeClass('header-fixed');
    }
});

$(document).ready(function() {
   $('#open-second-menu').on('click', function(event) {
       event.preventDefault();
       
        $('#second-navigation').addClass('active');
   });
   
   $('#close-second-menu').on('click', function(event) {
       event.preventDefault();
       
        $('#second-navigation').removeClass('active');
   });   
   
});